<template>
  <div>
    <van-cell :value="date" @click="show = true" />
    <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" position="top" />
  </div>
</template>
<script>
import { Calendar, Cell } from "vant";
export default {
  name: "calendarCard",
  components: {
    vanCalendar: Calendar,
    vanCell: Cell,
  },
  data() {
    return {
      date: "",
      show: false,
      minDate: new Date(2021, 6, 21),
      maxDate: new Date(2021, 7, 10),
    };
  },
  created() {
    let today = new Date();
    this.date = `${today.getMonth() + 1}月${today.getDate()}日`;
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
  },
};
</script>
<style lang="scss" scoped>
.van-cell__value--alone {
  text-align: center;
  color: #fff;
  font-size: 18px;
}
.van-cell{
  background-color: transparent;
  &::after{
    border:none;
  }
}
</style>